import { useEffect, useState } from 'react';
import request from '../../../../../../utils/request';
import { Box, Button, Checkbox, FormControlLabel, Table, TableCell, TableRow, Typography } from '@mui/material';
import Loader from 'src/pages/common/Loader';
import RelationShipItems from './RelationShipItems';
import WarningMessage from '../../WarningMessage';
import { isNull } from 'lodash';
import { selectDataListSectionIds, updateDataListSectionId } from 'src/features/rfqDataSlice';
import { useDispatch, useSelector } from 'react-redux';
function GmcTemplate({ rfqSectionId, summaryStructureData = null, handleCloseSummaryView = () => { }, warning = true, usedfrom = null, isFromView = false }) {

    const [errors, setErrors] = useState(null);
    const [loading, setLoading] = useState(false);
    const [ageRangeList, setAgeRangeList] = useState([]);
    const [summaryViewData, setSummaryViewData] = useState([]);
    const [createdAt, setCreatedAt] = useState(null);

    const [hovered, setHovered] = useState(false);
    const dispatch = useDispatch();

    // Get the current selected section IDs from Redux store
    const selectedSectionIds = useSelector(selectDataListSectionIds);


    const handleCheckboxChange = (event) => {
        const isChecked = event.target.checked;
        let updatedIds = [];

        if (isChecked) {
            // Append sectionId if not already in the list
            updatedIds = [...selectedSectionIds, rfqSectionId];
        } else {
            // Remove sectionId if unchecked
            updatedIds = selectedSectionIds?.filter(id => id !== rfqSectionId);
        }


        // Dispatch action to update Redux state
        dispatch(updateDataListSectionId({ data: updatedIds }));
    };



    useEffect(() => {

        if (summaryStructureData?.summary) {
            setSummaryViewData(summaryStructureData?.summary);
            setAgeRangeList(summaryStructureData?.ageRangeList);
            setCreatedAt(summaryStructureData?.createdAt)
        } else {
            getGMCSummaryViewData();
        }
    }, [summaryStructureData])
    const getGMCSummaryViewData = () => {
        setLoading(true)
        request({
            url: 'rfq/rfqGMCSummaryView',
            method: 'POST',
            data: {
                sumInsuredSectionid: rfqSectionId,
            }
        }).then((response: any) => {

            if (response.status == true) {
                if (response.data) {
                    setSummaryViewData(response.data.summary);
                    setAgeRangeList(response.data.ageRangeList);
                    setCreatedAt(response.data.createdAt)
                }
            } else {
                setErrors(response.message)
            }

            setLoading(false);

        }).catch(function (err) {
            setLoading(false)
        });
    }

    return (
        <>
            {loading && <Loader />}
            {errors && <Box
                sx={{
                    backgroundColor: '#ffebee',
                    padding: '16px',
                    borderRadius: '8px',
                    marginBottom: '16px',
                    textAlign: 'center',
                    marginTop: '15px'
                }}
            >
                <Typography variant="body1" color="error">
                    {errors}
                </Typography>
            </Box>}
            {!errors && !loading && <>

                <div
                    style={{ position: "relative", display: "inlineBlock" }}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                >

                    {isFromView && <Box
                        sx={{
                            position: "absolute",
                            top: "25px",
                            left: "0px",
                            width: hovered ? "200px" : "0px",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            transition: "width 0.4s ease-in-out",
                            background: "white",
                            padding: hovered ? "5px" : "0px",
                            border: hovered ? "1px solid #ccc" : "none",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <FormControlLabel
                            control={<Checkbox size="small"
                                checked={Array.isArray(selectedSectionIds) && selectedSectionIds.includes(rfqSectionId)}
                                onChange={handleCheckboxChange} />}
                            label={hovered ? "Show detailed data list" : ""}
                        />
                    </Box>}
                    {warning && <WarningMessage time={createdAt} />}
                    <Table className="summary-table" sx={{ minWidth: 650, marginTop: '20px' }} aria-label="simple table">
                        {/* Header Row */}
                        <TableRow>
                            <TableCell style={{ padding: 0 }}>
                                <div className="tableHeads alignItemLeft">Age band / Relation</div>
                            </TableCell>
                            {ageRangeList?.map((item, i) => (
                                <TableCell key={i} style={{ padding: 0 }}>
                                    <div className="tableHeads">{item}</div>
                                </TableCell>
                            ))}
                            <TableCell style={{ padding: 0 }}>
                                <div className="tableHeads">Grand Total</div>
                            </TableCell>
                        </TableRow>
                        {summaryViewData.map((summary, i) => {
                            const sumInsured = Object.keys(summary)[0];
                            const relationShips = summary[sumInsured];
                            return (<>
                                <TableRow>
                                    <TableCell style={{ padding: 0 }}>
                                        <div className="sumInsuredtableHeads alignItemLeft">Sum Insured</div>
                                    </TableCell>
                                    <TableCell style={{ padding: 0 }} colSpan={ageRangeList.length + 1}>
                                        <div className="sumInsuredtableHeads">{sumInsured}</div>
                                    </TableCell>
                                </TableRow>
                                {relationShips.map((relationShip) => {
                                    const relation = Object.keys(relationShip)[0];
                                    let countTotal = 0;
                                    return (

                                        <>
                                            <RelationShipItems relationShip={relationShip} relation={relation} ageRangeList={ageRangeList} leftLabel={relation} sumType={'count'} />
                                            {usedfrom != 'rfq' && <RelationShipItems relationShip={relationShip} relation={relation} ageRangeList={ageRangeList} leftLabel={'Per Member Premium'} sumType={'premium'} bg={'bgWite'} />}
                                            {usedfrom != 'rfq' && <RelationShipItems relationShip={relationShip} relation={relation} ageRangeList={ageRangeList} leftLabel={'Total Premium'} sumType={'totalPremium'} bg={'bgWite'} />}
                                        </>
                                    )
                                })}
                            </>)
                        })}

                    </Table>
                </div>
            </>}

            {/* here warning flag always true. only one case is false that is in rfq view section */}
            {warning && <Button
                variant="contained"
                color="primary"
                type="button"
                onClick={handleCloseSummaryView}
                style={{ marginTop: '10px' }}
            >
                Re-Generate Summary View
            </Button>}


        </>
    )
}

export default GmcTemplate